
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Åbn din browsermenu`,
's182ab2d6c997515f': `Tilføj den til din hjemmeskærm for en bedre oplevelse og nem adgang.`,
's1b9047d53d9f9d22': `2) Tryk på Del-knappen i navigationslinjen`,
's2d90afa5dcca2c0e': `3) Rul ned til "Tilføj til hjemmeskærm"`,
's37a9e8aec5713460': `Mere`,
's4593f304dac8848c': `2) Tryk på "Tilføj til hjemmeskærm"`,
's54cfbb14f46396d4': `1) Åbn i din primære browser`,
's6196153c4b0c1ea0': `Installer`,
's922329d6f6213590': `Tilføj til Dock`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sa7551383d1897fcc': `2) Vælg Tilføj til Dock`,
'sba52286c21552a4e': `Installer den på din enhed for en bedre oplevelse og nem adgang.`,
'sc79fd7641eb9a975': `Skjul instruktion`,
'scdaf4bbff76674c8': `Tilføj til hjemmeskærm`,
'se740f75b95a51807': `Tilføj den til din Dock for en bedre oplevelse og nem adgang.`,
'sfea652f6580ff086': `Denne side har app-funktionalitet.`,
    };
  